import { render, staticRenderFns } from "./TagSelect.vue?vue&type=template&id=a5900bcc&scoped=true&"
import script from "./TagSelect.vue?vue&type=script&lang=js&"
export * from "./TagSelect.vue?vue&type=script&lang=js&"
import style0 from "./TagSelect.vue?vue&type=style&index=0&id=a5900bcc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5900bcc",
  null
  
)

export default component.exports